import React from "react"
import PropTypes from "prop-types"

const styles = {
  available: 'bg-available cursor-pointer hover:bg-blue-500',
  unavailable: 'bg-unavailable',
  guardian_booked: 'bg-gray-400',
  selected: 'bg-selected cursor-pointer hover:bg-blue-400',
}

const Slot = ({ caption, handleClick, status }) => {
  const slotClasses = styles[status];
    
  return (
    <div 
      className={`flex items-center text-sm justify-center font-bold p-2 text-white rounded-sm ${slotClasses}`} 
      onClick={() => handleClick()}
    >
      {caption}
    </div>
  )
}

Slot.propTypes = {
  handleClick: PropTypes.func.isRequired,
  caption: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
}

export default Slot